import { useGlobal } from "@/app/providers/use-global";
import { useUser } from "@/shared/providers/user-provider";
import UserAuthForm from "./forms/user-auth-form";

export default function LoginCard() {
  const { stytchUser, logout } = useUser();
  const { isLoginEmailSent, setIsLoginEmailSent, isUserLoggedIn } = useGlobal();

  return (
    <>
      {isUserLoggedIn && stytchUser && (
        <div>
          <p>You are currently logged in as {stytchUser?.email_address}</p>
          <button className="mt-4" onClick={() => logout()} type="button">
            Log Out
          </button>
        </div>
      )}
      {isLoginEmailSent && !isUserLoggedIn && (
        <div>
          <h1 className="relative text-xl font-semibold mb-4">
            Check your email
          </h1>
          <p className="text-sm text-muted-text">
            An email was sent to <strong>{isLoginEmailSent}</strong>
          </p>
          <p className="mt-4 text-sm text-muted-text opacity-75">
            Not seeing an email?{" "}
            <button
              type="button"
              className="text-foreground hover:underline pointer"
              onClick={() => setIsLoginEmailSent("")}
            >
              Send another email
            </button>
          </p>
        </div>
      )}

      {!(isLoginEmailSent || isUserLoggedIn) && <UserAuthForm />}
    </>
  );
}
